export default __webpack_public_path__ + "static/media/grammer.bbcfa6c4.png";